/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Tool usage aggregation target kind
 */
export const ToolUsageUsersByTargetRowTargetKind = {
  Server: "server",
  LocalTools: "local_tools",
  Skill: "skill",
} as const;
/**
 * Tool usage aggregation target kind
 */
export type ToolUsageUsersByTargetRowTargetKind = OpenEnum<
  typeof ToolUsageUsersByTargetRowTargetKind
>;

/**
 * Tool usage target type
 */
export const ToolUsageUsersByTargetRowTargetType = {
  HostedMcpServer: "hosted_mcp_server",
  TunneledMcpServer: "tunneled_mcp_server",
  MetaMcpServer: "meta_mcp_server",
  ShadowMcpServer: "shadow_mcp_server",
  LocalTool: "local_tool",
  Skill: "skill",
} as const;
/**
 * Tool usage target type
 */
export type ToolUsageUsersByTargetRowTargetType = OpenEnum<
  typeof ToolUsageUsersByTargetRowTargetType
>;

/**
 * Tool usage user identity kind
 */
export const ToolUsageUsersByTargetRowUserKind = {
  Email: "email",
  ExternalUserId: "external_user_id",
  UserId: "user_id",
  AgentId: "agent_id",
  Unknown: "unknown",
} as const;
/**
 * Tool usage user identity kind
 */
export type ToolUsageUsersByTargetRowUserKind = OpenEnum<
  typeof ToolUsageUsersByTargetRowUserKind
>;

/**
 * Aggregated tool usage metrics for one target and user identity
 */
export type ToolUsageUsersByTargetRow = {
  /**
   * Total number of tool usage events for the target and user identity
   */
  eventCount: number;
  /**
   * Number of failed tool usage events for the target and user identity
   */
  failureCount: number;
  /**
   * Stable target identifier used by filters and chart grouping
   */
  targetId: string;
  /**
   * Tool usage aggregation target kind
   */
  targetKind: ToolUsageUsersByTargetRowTargetKind;
  /**
   * User-facing label for the target
   */
  targetLabel: string;
  /**
   * Tool usage target type
   */
  targetType: ToolUsageUsersByTargetRowTargetType;
  /**
   * Stable user identity value used by filters and chart grouping
   */
  userKey: string;
  /**
   * Tool usage user identity kind
   */
  userKind: ToolUsageUsersByTargetRowUserKind;
  /**
   * User-facing label for the user identity
   */
  userLabel: string;
};

/** @internal */
export const ToolUsageUsersByTargetRowTargetKind$inboundSchema: z.ZodMiniType<
  ToolUsageUsersByTargetRowTargetKind,
  unknown
> = openEnums.inboundSchema(ToolUsageUsersByTargetRowTargetKind);

/** @internal */
export const ToolUsageUsersByTargetRowTargetType$inboundSchema: z.ZodMiniType<
  ToolUsageUsersByTargetRowTargetType,
  unknown
> = openEnums.inboundSchema(ToolUsageUsersByTargetRowTargetType);

/** @internal */
export const ToolUsageUsersByTargetRowUserKind$inboundSchema: z.ZodMiniType<
  ToolUsageUsersByTargetRowUserKind,
  unknown
> = openEnums.inboundSchema(ToolUsageUsersByTargetRowUserKind);

/** @internal */
export const ToolUsageUsersByTargetRow$inboundSchema: z.ZodMiniType<
  ToolUsageUsersByTargetRow,
  unknown
> = z.pipe(
  z.object({
    event_count: z.int(),
    failure_count: z.int(),
    target_id: z.string(),
    target_kind: ToolUsageUsersByTargetRowTargetKind$inboundSchema,
    target_label: z.string(),
    target_type: ToolUsageUsersByTargetRowTargetType$inboundSchema,
    user_key: z.string(),
    user_kind: ToolUsageUsersByTargetRowUserKind$inboundSchema,
    user_label: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "event_count": "eventCount",
      "failure_count": "failureCount",
      "target_id": "targetId",
      "target_kind": "targetKind",
      "target_label": "targetLabel",
      "target_type": "targetType",
      "user_key": "userKey",
      "user_kind": "userKind",
      "user_label": "userLabel",
    });
  }),
);

export function toolUsageUsersByTargetRowFromJSON(
  jsonString: string,
): SafeParseResult<ToolUsageUsersByTargetRow, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolUsageUsersByTargetRow$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolUsageUsersByTargetRow' from JSON`,
  );
}
